<div class="term-condition">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <h4>Terms & Conditions</h4>
    </div>
  </div>
  <div class="row" *ngIf="showTC">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="terms-content">
        <p [innerHTML]="termsContent"></p>
      </div>
    </div>
  </div>
  <div
    class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center update-notice"
  >
    <p class="update-notice__text">
      Our Terms & Conditions have recently changed.
    </p>
  </div>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <div class="form-group wab-btn-footer">
        <button
          type="button"
          class="btn wb-btn-default center-block"
          [disabled]="loading"
          (click)="onAccepted()"
        >
          I Have Read & Accepted
          <span *ngIf="loading" class="loading-animation"></span>
        </button>
        <button
          type="button"
          class="btn wb-btn-outline center-block"
          [disabled]="loading"
          (click)="onViewTermsAndConditions()"
        >
          View Terms & Conditions
        </button>
      </div>
    </div>
  </div>
</div>
